// Глобальный реестр очисток/отмен
class Reaper {
  constructor() {
    this.cleanups = new Set()
    this.aborters = new Set()
  }

  add(disposer) {
    if (typeof disposer === 'function') this.cleanups.add(disposer)
    return disposer
  }

  addAborter(ac) {
    if (ac) this.aborters.add(ac)
    return ac
  }

  makeAborter() {
    const ac = new AbortController()
    this.aborters.add(ac)
    return ac
  }

  setTimeout(fn, ms, ...args) {
    const id = window.setTimeout(fn, ms, ...args)
    this.add(() => clearTimeout(id))
    return id
  }

  setInterval(fn, ms, ...args) {
    const id = window.setInterval(fn, ms, ...args)
    this.add(() => clearInterval(id))
    return id
  }

  addEventListener(target, type, listener, options) {
    target.addEventListener(type, listener, options)
    this.add(() => target.removeEventListener(type, listener, options))
  }

  observe(mo, target, opts) {
    mo.observe(target, opts)
    this.add(() => mo.disconnect())
  }

  killAll() {
    // abort fetch/долгих задач
    for (const ac of this.aborters) { try { ac.abort() } catch(e){} }
    this.aborters.clear()
    // отписки/таймеры/слушатели и т. п.
    for (const fn of this.cleanups) { try { fn() } catch(e){} }
    this.cleanups.clear()
  }
}

export const reaper = new Reaper()



// WEBPACK FOOTER //
// ./src/utils/rapper.js